import axios from 'axios';

// const API_URL = process.env.REACT_APP_API_URL + "/v1/client/";
const API_URL = "http://localhost:3004";

const getClinicSurveyList = (clinicId) => {
    return axios.get(`${API_URL}/surveys`);
};

const getSurveyTemplates = () => {
    return axios.get(`${API_URL}/survey_templates`);
};

// ✅ Assign to a variable before exporting
const surveyService = {
    getClinicSurveyList,
    getSurveyTemplates
};

export default surveyService;
